exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chip[data-v-7c67565c]:hover {\n  background-color: #F5B821 !important;\n  border-color: #F5B821 !important;\n  color: white !important;\n}", ""]);

// exports
